module.exports = __webpack_public_path__ + "img/polyamid.3824e252.png";